import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { DischargePlanningQuestionnaireItem } from './questionnaire'

export const DISCHARGE_PLANNING_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING]: QuestionnaireAnswerType.GROUP,
  [DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING_DISCHARGE_PLANS]:
    QuestionnaireAnswerType.STRING,
  [DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING_REHABILITATION_POTENTIAL]:
    QuestionnaireAnswerType.STRING,
  [DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING_NOTES]: QuestionnaireAnswerType.STRING
}
